var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGridsvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1081,
    viewBox: "0 0 1440 1081",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 51.5,
    x2: 1440,
    y2: 51.5,
    stroke: "#9B9B9B",
    strokeOpacity: 0.1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: 96.5,
    x2: 1440,
    y2: 96.5,
    stroke: "#9B9B9B",
    strokeOpacity: 0.1
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: 141.5,
    x2: 1440,
    y2: 141.5,
    stroke: "#9B9B9B",
    strokeOpacity: 0.1
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: 186.5,
    x2: 1440,
    y2: 186.5,
    stroke: "#9B9B9B",
    strokeOpacity: 0.1
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    y1: 231.5,
    x2: 1440,
    y2: 231.5,
    stroke: "#9B9B9B",
    strokeOpacity: 0.1
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    y1: 276.5,
    x2: 1440,
    y2: 276.5,
    stroke: "#9B9B9B",
    strokeOpacity: 0.1
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    y1: 321.5,
    x2: 1440,
    y2: 321.5,
    stroke: "#9B9B9B",
    strokeOpacity: 0.1
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    y1: 366.5,
    x2: 1440,
    y2: 366.5,
    stroke: "#9B9B9B",
    strokeOpacity: 0.1
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    y1: 411.5,
    x2: 1440,
    y2: 411.5,
    stroke: "#9B9B9B",
    strokeOpacity: 0.1
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    y1: 456.5,
    x2: 1440,
    y2: 456.5,
    stroke: "#9B9B9B",
    strokeOpacity: 0.1
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    y1: 501.5,
    x2: 1440,
    y2: 501.5,
    stroke: "#9B9B9B",
    strokeOpacity: 0.1
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    y1: 546.5,
    x2: 1440,
    y2: 546.5,
    stroke: "#9B9B9B",
    strokeOpacity: 0.1
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    y1: 591.5,
    x2: 1440,
    y2: 591.5,
    stroke: "#9B9B9B",
    strokeOpacity: 0.1
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    y1: 636.5,
    x2: 1440,
    y2: 636.5,
    stroke: "#9B9B9B",
    strokeOpacity: 0.1
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    y1: 681.5,
    x2: 1440,
    y2: 681.5,
    stroke: "#9B9B9B",
    strokeOpacity: 0.1
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 34.5001,
    y1: 1,
    x2: 34.5,
    y2: 682,
    stroke: "#9B9B9B",
    strokeOpacity: 0.1
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 79.5001,
    y1: 1,
    x2: 79.5001,
    y2: 682,
    stroke: "#9B9B9B",
    strokeOpacity: 0.1
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 124.5,
    y1: 1,
    x2: 124.5,
    y2: 682,
    stroke: "#9B9B9B",
    strokeOpacity: 0.1
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 169.5,
    y1: 1,
    x2: 169.5,
    y2: 682,
    stroke: "#9B9B9B",
    strokeOpacity: 0.1
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 214.5,
    y1: 1,
    x2: 214.5,
    y2: 682,
    stroke: "#9B9B9B",
    strokeOpacity: 0.1
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 259.5,
    y1: 1,
    x2: 259.5,
    y2: 682,
    stroke: "#9B9B9B",
    strokeOpacity: 0.1
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 304.5,
    y1: 1,
    x2: 304.5,
    y2: 682,
    stroke: "#9B9B9B",
    strokeOpacity: 0.1
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 349.5,
    y1: 1,
    x2: 349.5,
    y2: 682,
    stroke: "#9B9B9B",
    strokeOpacity: 0.1
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 394.5,
    y1: 1,
    x2: 394.5,
    y2: 682,
    stroke: "#9B9B9B",
    strokeOpacity: 0.1
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 439.5,
    y1: 1,
    x2: 439.5,
    y2: 682,
    stroke: "#9B9B9B",
    strokeOpacity: 0.1
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 484.5,
    y1: 1,
    x2: 484.5,
    y2: 682,
    stroke: "#9B9B9B",
    strokeOpacity: 0.1
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 529.5,
    y1: 1,
    x2: 529.5,
    y2: 682,
    stroke: "#9B9B9B",
    strokeOpacity: 0.1
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 574.501,
    y1: 1,
    x2: 574.5,
    y2: 682,
    stroke: "#9B9B9B",
    strokeOpacity: 0.1
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 619.501,
    y1: 1,
    x2: 619.501,
    y2: 682,
    stroke: "#9B9B9B",
    strokeOpacity: 0.1
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 664.501,
    y1: 1,
    x2: 664.501,
    y2: 682,
    stroke: "#9B9B9B",
    strokeOpacity: 0.1
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 709.501,
    y1: 1,
    x2: 709.501,
    y2: 682,
    stroke: "#9B9B9B",
    strokeOpacity: 0.1
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 754.501,
    y1: 1,
    x2: 754.501,
    y2: 682,
    stroke: "#9B9B9B",
    strokeOpacity: 0.1
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    x1: 799.501,
    y1: 1,
    x2: 799.501,
    y2: 682,
    stroke: "#9B9B9B",
    strokeOpacity: 0.1
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    x1: 844.501,
    y1: 1,
    x2: 844.501,
    y2: 682,
    stroke: "#9B9B9B",
    strokeOpacity: 0.1
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    x1: 889.501,
    y1: 1,
    x2: 889.501,
    y2: 682,
    stroke: "#9B9B9B",
    strokeOpacity: 0.1
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    x1: 934.501,
    y1: 1,
    x2: 934.501,
    y2: 682,
    stroke: "#9B9B9B",
    strokeOpacity: 0.1
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    x1: 979.501,
    y1: 1,
    x2: 979.501,
    y2: 682,
    stroke: "#9B9B9B",
    strokeOpacity: 0.1
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    x1: 1024.5,
    y1: 1,
    x2: 1024.5,
    y2: 682,
    stroke: "#9B9B9B",
    strokeOpacity: 0.1
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    x1: 1069.5,
    y1: 1,
    x2: 1069.5,
    y2: 682,
    stroke: "#9B9B9B",
    strokeOpacity: 0.1
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    x1: 1114.5,
    y1: 1,
    x2: 1114.5,
    y2: 682,
    stroke: "#9B9B9B",
    strokeOpacity: 0.1
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    x1: 1159.5,
    y1: 1,
    x2: 1159.5,
    y2: 682,
    stroke: "#9B9B9B",
    strokeOpacity: 0.1
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    x1: 1204.5,
    y1: 1,
    x2: 1204.5,
    y2: 682,
    stroke: "#9B9B9B",
    strokeOpacity: 0.1
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    x1: 1249.5,
    y1: 1,
    x2: 1249.5,
    y2: 682,
    stroke: "#9B9B9B",
    strokeOpacity: 0.1
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    x1: 1294.5,
    y1: 1,
    x2: 1294.5,
    y2: 682,
    stroke: "#9B9B9B",
    strokeOpacity: 0.1
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    x1: 1339.5,
    y1: 1,
    x2: 1339.5,
    y2: 682,
    stroke: "#9B9B9B",
    strokeOpacity: 0.1
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    x1: 1384.5,
    y1: 1,
    x2: 1384.5,
    y2: 682,
    stroke: "#9B9B9B",
    strokeOpacity: 0.1
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    x1: 1429.5,
    y1: 1,
    x2: 1429.5,
    y2: 682,
    stroke: "#9B9B9B",
    strokeOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridsvg);
export default __webpack_public_path__ + "static/media/gridsvg.1f69c8fbaa5b7217f336f8dd90fa638e.svg";
export { ForwardRef as ReactComponent };